<template>
  <div
    :class="{ 'rt-detail-header-shadow': shadow,'rt-detail-header-small':small,'rt-detail-header-hide-bg':hiddenBg }"
    class="rt-detail-header"
  >
    <div
      v-if="!!$slots.icon"
      class="header-icon"
    >
      <slot name="icon" />
    </div>
    <div class="header-content">
      <slot />
    </div>
    <div class="header-btns">
      <slot name="btn" />
    </div>
    <rt-button
      v-if="showBack"
      class="rt-btn-back"
      icon-name="rt-base-back"
      @click="back"
    >
      {{
        $tx('返回', 'xpc.detailheader.back')
      }}
    </rt-button>
  </div>
</template>

<script>
import RtButton from '../../button/rtButton';
export default {
  name: 'RtDetailHeader',
  components: { RtButton },
  props: {
    showBack: {
      type: Boolean,
      default: true
    },
    autoBack: {
      type: Boolean,
      default: true
    },
    shadow: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: false
    },
    hiddenBg: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    back () {
      if (this.autoBack) {
        this.$router.back();
        return;
      }
      this.$emit('back');
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtDetailHeader.vue?89bc9c40